$(document).on('click', '.creative-pre-approval-inactive-btn', function() {
  $('#creative_pre_approvals .creative-pre-approval-card:visible').each(function() {
    $(this).attr('data-auto-removed', 'true');
    $(this).find('.remove_fields .fa-circle-x').click();
  });
});

$(document).on('click', '.creative-pre-approval-active-btn', function() {
  $('#creative_pre_approvals .creative-pre-approval-card[data-auto-removed="true"]').each(function() {
    var card = $(this);
    card.removeAttr('data-auto-removed').show().find('.remove_fields').prev('input[type=hidden]').val('0');
  });
  renumberCreativePreApprovals();
  updateNeedsResubmissionBanner();
});

function renumberCreativePreApprovals() {
  $('#creative_pre_approvals .creative-pre-approval-card:visible').each(function(index) {
    $(this).find('.group-name').text(index + 1);
  });
}

function setCardBadge(card, label, cssClass) {
  var $badge = $(card).find('.pre-approval-card-badge');
  if ($badge.length === 0) {
    $badge = $('<span class="badge pre-approval-card-badge"></span>');
    $(card).find('.card-header .float-right.remove-link').prepend($badge);
  } else if ($(card).data('originalBadgeLabel') === undefined) {
    $(card).data('originalBadgeLabel', $badge.text());
    $(card).data('originalBadgeClass', $badge.attr('class'));
  }
  $badge.attr('class', 'badge pre-approval-card-badge ' + cssClass).text(label);
}

function revertCardBadge(card) {
  var label = $(card).data('originalBadgeLabel');
  var cssClass = $(card).data('originalBadgeClass');
  if (label === undefined) return;
  $(card).find('.pre-approval-card-badge').attr('class', cssClass).text(label);
}

function updateNeedsResubmissionBanner() {
  if ($('#creative_pre_approvals').data('hasExistingPreapprovals') !== true) {
    $('.creative-pre-approval-needs-resubmission-banner').hide();
    return;
  }

  var needsResubmission = $('#creative_pre_approvals .creative-pre-approval-card:visible[data-pending-resubmission="true"]').length > 0;
  $('.creative-pre-approval-needs-resubmission-banner').toggle(needsResubmission);
}

$(document).on('cocoon:after-insert', '#creative_pre_approvals', function(e, insertedItem) {
  insertedItem.find('select[data-ajax][data-tom-select]').each(function() {
    if (!this.tomselect) $(this).defaultTomSelect();
  });
  insertedItem.find('select[data-dynamic-chosen]').each(function() {
    if (!$(this).data('chosen')) $(this).dynamicChosen();
  });
  insertedItem.find('select:not([data-ajax]):not([data-dynamic-chosen])').each(function() {
    if (!$(this).data('chosen')) $(this).defaultChosen();
  });
  renumberCreativePreApprovals();
  setCardBadge(insertedItem, 'New', 'badge-new');
});

function selectValueChanged($select) {
  var current = $select.val();
  var original = $select.data('originalValue');

  if (Array.isArray(current)) {
    var originalArr = Array.isArray(original) ? original : (original ? JSON.parse(original) : []);
    var currentValues = current.filter(Boolean).map(String).slice().sort();
    var originalValues = originalArr.filter(Boolean).map(String).slice().sort();
    return JSON.stringify(currentValues) !== JSON.stringify(originalValues);
  }

  return String(current || '') !== String(original || '');
}

function cardHasPendingChanges(card) {
  var pending = false;
  $(card).find('select').each(function() {
    if (selectValueChanged($(this))) pending = true;
  });
  return pending;
}

$(document).on('change', '#creative_pre_approvals .creative-pre-approval-card select', function() {
  var card = $(this).closest('.creative-pre-approval-card');
  var pending = cardHasPendingChanges(card);
  var isExisting = card.find('.remove_fields').hasClass('existing');

  if (isExisting) {
    if (pending) {
      setCardBadge(card, 'Modified', 'badge-modified');
    } else {
      revertCardBadge(card);
    }
    card.find('.pre-approval-feedback-banner').toggle(!pending);
  }
  card.attr('data-pending-resubmission', pending);
  updateNeedsResubmissionBanner();
});

$(document).on('cocoon:after-remove', '#creative_pre_approvals', function() {
  renumberCreativePreApprovals();
  updateNeedsResubmissionBanner();
});
